
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DLCompany } from './company';
import { DLCompanyService, DLCompanyFilter } from './company.service';
import { DLCompanyFilterDialogComponent } from './company-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'dl-companies.filter';

@Component({
  templateUrl: './company-list.component.html',
})
export class DLCompanyListComponent implements OnInit {

  filter: DLCompanyFilter;

  perPage = 10
  companiesCount: number = 0
  companies: DLCompany[]

  constructor(
    private companyService: DLCompanyService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new DLCompanyFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.companies.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.companyService
      .companies(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.companies = result.companies;
        }
        // Append
        else {
          this.companies = [...this.companies || [], ...result.companies];
        }

        this.companiesCount = result.companiesCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showDLCompany(company: DLCompany, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['documents-ledger', 'companies', company.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: DLCompanyFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: DLCompanyFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  delete(company: DLCompany) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette société?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.companyService
          .delete(company.id)
          .subscribe((id) => {
            this.notifier.success('Société supprimé avec succès');

            this.fetch(0, this.companies.length, true);
          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
